module.exports = __webpack_public_path__ + "img/sdk-2-1.f13b5c0.svg";